module.exports = __webpack_public_path__ + "SHSADCAA/static/media/movie-videos.2331e50a.svg";